import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      © {new Date().getFullYear()} Austin Seaman. All rights reserved.
    </footer>
  );
}
